import React, { useState } from 'react';
import { motion } from 'framer-motion';

const cases = [
    {
        client: "グローバル食品・飲料企業",
        category: "クラウド移行 & モダナイゼーション",
        items: [
            "オンプレミスからAzure PaaSへのクラウドマイグレーション&モダナイゼーション支援",
            "全社データ活用基盤のETL/データモデリング支援",
            "すでに開発された機械学習によるシステムの実装評価",
            "システム再構築にかかる機能改善検討、ロードマップ策定"
        ]
    },
    {
        client: "国内大手小売企業",
        category: "インフラ & データ活用",
        items: [
            "販売店のネットワーク環境評価と改善のための社内アプリケーション設計・構築",
            "本部でのデータ活用におけるBIレポート作成、スマートモニター設計支援",
            "IdP見直しにかかる製品比較検討、要件定義支援、ベンダー調整・調達支援"
        ]
    },
    {
        client: "独立行政法人(経済産業省系列)",
        category: "システム開発・データ分析に関するアドバイザー(専門委員)",
        items: [
            "マルチクラウドシステムの開発に関するベンダー協議支援",
            "省庁との連携施策に関し、市場データの取りまとめとデータ分析",
            "プロジェクト推進関連での議論推進方法に関する相談、壁打ち支援"
        ]
    },
    {
        client: "大手会計コンサルティング企業",
        category: "Microsoft製品の活用に関する技術アドバイザリ + 検証環境運用",
        items: [
            "業界向けアプリテンプレートの開発に向けたMicrosoft技術を用いた設計支援",
            "アプリテンプレートのアーキテクチャー、運用方針に関するレビュー、アドバイス",
            "検証用の環境構築とライセンス調達"
        ]
    },
    {
        client: "米系データ活用・AIソリューション企業",
        category: "SaaS製品のアドバイザリーパートナー受託",
        items: [
            "コンテキストエンジニアリングの活用に関するSaaSアドバイザリー",
            "Observability、Security文脈でのデータ活用に関するアドバイザリー",
            "分散コンピューティングの活用による処理効率化に関するPoC、チューニング支援"
        ]
    }
];

const INITIAL_VISIBLE_CASES = 6;

const CaseStudies = () => {
    const [showAll, setShowAll] = useState(false);
    const visibleCases = showAll ? cases : cases.slice(0, INITIAL_VISIBLE_CASES);

    const renderCard = (item, key) => (
        <div
            key={key}
            className="bg-gray-50 dark:bg-gray-700 rounded-xl overflow-hidden shadow-lg border border-gray-100 dark:border-gray-600"
        >
            <div className="p-8">
                <div className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2 tracking-wide uppercase">
                    {item.category}
                </div>
                <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">
                    {item.client}
                </h3>
                <ul className="space-y-3">
                    {item.items.map((subItem, subIndex) => (
                        <li key={subIndex} className="flex items-start gap-3 text-gray-600 dark:text-gray-300">
                            <span className="w-1.5 h-1.5 bg-gray-900 dark:bg-white rounded-full mt-2 flex-shrink-0" />
                            <span>{subItem}</span>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );

    return (
        <section id="case-studies" aria-labelledby="case-studies-title" className="py-20 bg-white dark:bg-gray-800 transition-colors duration-300 scroll-mt-16">
            <div className="container mx-auto px-4 md:px-6">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                    viewport={{ once: true }}
                    className="text-center mb-16"
                >
                    <h2 id="case-studies-title" className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-4">実績・事例</h2>
                    <p className="text-gray-600 dark:text-gray-300">実績・事例の一部をご紹介します。</p>
                </motion.div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    {visibleCases.map((item) => renderCard(item, item.client))}
                </div>
                {cases.length > INITIAL_VISIBLE_CASES && (
                    <div className="text-center mt-10">
                        <button
                            type="button"
                            onClick={() => setShowAll((current) => !current)}
                            className="px-8 py-3 rounded-full border border-gray-900 dark:border-white text-gray-900 dark:text-white font-semibold hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
                        >
                            {showAll ? '表示を減らす' : 'もっと見る'}
                        </button>
                    </div>
                )}
            </div>
        </section>
    );
};

export default CaseStudies;
